<template>
    <div class="dap-top-data-filter data-filter-dap">

        <div class="dap-top-filter-left">
            <slot name="left"></slot>
            <template v-if="leftOptionsComputed.key">
                <img class="gameImg m-r-10" :src="getIconUrl(selectData[leftOptionsComputed.key], leftOptionsComputed)" alt="" @error="handleImageError">
                <div v-if="leftOptionsComputed.disabled" style="height:32px;line-height: 32px;font-size: 14px;">{{getGameName(selectData[leftOptionsComputed.key], leftOptionsComputed)}}</div>
                <el-select v-else class="none-border dap-select__auto-width" :value="getGameName(selectData[leftOptionsComputed.key], leftOptionsComputed)" @change="(id) => handleFilterChangeId(id, leftOptionsComputed)">
                    <el-option
                        :class="getItemDisabled(item, leftOptionsComputed) ? 'c-blue' : ''"
                        v-for="item in gameList" :key="getItemValue(item, leftOptionsComputed)"
                        :value="getItemValue(item, leftOptionsComputed)" :label="getItemLabel(item, leftOptionsComputed)">
                    </el-option>
                    <template slot="prefix">
                        {{ getItemLabel(selectData[leftOptionsComputed.key], leftOptionsComputed) }}
                    </template>
                </el-select>
            </template>
        </div>

        <div class="dap-top-filter-right">
              <div class="tag-area">
                <div class="tag-content" v-for="(item,index) in resultList" :key="Math.random()*index">
                  <div class="tag-classify" v-if="item.title">{{ item.title }}：</div>
                  <div class="result-cn">
                  <div
                    class="result-wrapper flex-center lh24 p-r-4"
                    v-for="(result, idx) in item.data"
                    :key="idx">
                    <span class="f12 m-r-4 tag-item">{{getItemLabel(result, result)}}</span>
                    <i class="el-icon-error f14 hand" v-if="isShowRemoveBtn(result)" @click="removeResult(result)"></i>
                  </div>
                </div>
              </div>
            </div>
            <template v-for="filter in options">
                <el-dropdown v-if="['multi-select', 'select'].includes(filter.type)" :key="filter.key"
                    :trigger="filter.disabled ? '' : 'click'"
                    placement="bottom"
                    @command="(res) => handleFilterChange(res, filter)">
                    <DapPopover
                        v-bind="iconPopoverOption(filter)">
                        <div class="f12 c-666" v-html="getIconPopover(filter)"></div>
                        <i slot="reference" class="m-r-20 hand" :class="{ 'not-allowed': filter.disabled }">
                            <icon-svg v-if="filter.icon" class="f20" :icon-class="filter.icon" />
                            <span v-else>{{filter.title}}</span>
                        </i>
                    </DapPopover>

                    <el-dropdown-menu
                        class="dap-dropdown"
                        slot="dropdown"
                        style="max-height: 240px; overflow-y: auto; white-space: nowrap;"
                    >
                        <div v-for="(item, index) in innerLists[filter.key]" :key="getItemValue(item, filter) + index">
                            <DapPopover v-bind="itemPopoverOption(item, filter)">
                                <div class="f12 c-666" v-html="getItemPopover(item, filter)"></div>
                                <div slot="reference">
                                    <el-dropdown-item :disabled="getItemDisabled(item, filter)" :command="item">
                                        {{ getItemLabel(item, filter) }}
                                    </el-dropdown-item>
                                </div>
                            </DapPopover>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
                <!-- 时区 timezone -->
                <span
                    :key="filter.key" :class="{ 'not-allowed': filter.disabled }"
                    class="hand relative timezone-wrap" v-if="filter.type === 'timezone'"
                    @click="handleChangeTimezone(filter)">
                    <span class="timezone-tip timezone-tip-react timezone-tip-reset">{{ `${timezone > 0 ? '+' : ''}${timezone}` }}</span>
                    <icon-svg class="f20 timezone" :iconClass="filter.icon"></icon-svg>
                </span>
                <!-- 时间选择器 -->
                <div v-if="filter.type === 'date'" :key="filter.key">
                    <div class="p-r-10 hand m-r-10 relative" style="transform: translateY(-2px);text-align: right;border-left: 1px solid #F2F6FC;border-right: 1px solid #F2F6FC;"
                         @click="handleDateClick" :class="{ 'not-allowed': filter.disabled }">
                        <div class="data-filter-dap-date-picker-react hand" :class="{ 'not-allowed': filter.disabled }">
                            <el-date-picker
                                ref="dapDateRefs" size="small" :disabled="filter.disabled"
                                :style="{width: dateWidth, marginLeft: '-31px'}"
                                v-model="datePeriod" popper-class="data-filter-popper data-filter-popper-2 data-filter-date"
                                :start-placeholder="filter.startPlaceHolder" :end-placeholder="filter.endPlaceHolder"
                                :type="filter.datePickerType" :format="filter.format" :value-format="filter.valueFormat || 'yyyy-MM-dd'"
                                :range-separator="filter.separator" :default-value="filter.defaultValue"
                                :picker-options="pickerOptionsComputed" @blur="handleDateBlur">
                            </el-date-picker>
                        </div>
                        <div class="relative date-react-word-wrap" style="top: 2px">
                            <span class="f14 bold date-react-word">
                                {{ dateText }}
                                <i class="el-icon-caret-bottom"></i>
                            </span>
                        </div>
                        <div class="p-l-10 f12" :class="{hasDateOptions: dateOptions.key, 'not-allowed': filter.disabled}" style="height: 21px;line-height: 21px;clear: both;" id="dateNameWrap">
                            <span>{{ dateName }}</span>
                        </div>
                        <div class="hand inline-block relative date-type-tip-wrap" v-if="dateOptions.key">
                            <slot v-if="dateOptions.type === 'slot'" :name="dateOptions.key"></slot>
                            <el-dropdown v-else
                                :key="dateOptions.key"
                                :trigger="dateOptions.disabled ? '' : 'click'"
                                placement="bottom"
                                @visible-change="handleDateDropdown"
                                @command="(res) => handleFilterChange(res, dateOptions)">
                                <span class="hand f12" :class="{ 'not-allowed': dateOptions.disabled }">
                                    {{ getItemLabel(selectData[dateOptions.key], dateOptions) }}
                                    <DapPopover trigger="hover" :disabled="!showDateTips">
                                        <div class="f12">{{dateOptions.tips}}</div>
                                        <icon-svg v-if="dateOptions.icon" slot="reference" class="f14" :icon-class="dateOptions.icon" />
                                        <i v-else slot="reference" class="m-l-2 el-icon-s-tools"></i>
                                    </DapPopover>
                                </span>
                                <el-dropdown-menu
                                    slot="dropdown"
                                    class="dap-dropdown dap-extra-dropdown"
                                    :class="(dateOptions.datalist || []).length ? '' : 'hide-element'"
                                >
                                    <el-dropdown-item
                                        v-for="item in dateOptions.datalist"
                                        :key="getItemValue(item, dateOptions)"
                                        :disabled="getItemDisabled(item, dateOptions)"
                                        :command="item"
                                    >{{getItemLabel(item, dateOptions)}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
            </template>
            <i v-if="showRefreshComputed"
               class="hand p-t-2"
               @click="handleRefresh">
                <icon-svg class="f20" icon-class="statusbar-refresh" />
            </i>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { getShortcuts, getQuickTime } from '../util/shortcuts';
import DapIconSvg from "../../icon-svg";
import DapPopover from "../../popover";
import defaultImage from './icon-game-default.png'

dayjs.extend(isoWeek);

export default {
    name: 'DapTopFilter',

    components: {
        IconSvg: DapIconSvg,
        DapPopover,
    },

    props: {
        filterData: {
            type: Object,
            default: () => ({}),
        },
        leftOptions: {
            type: Object,
        },
        options: {
            type: Array,
            default: () => []
        },
        timeIconTip: {
            type: String,
            default: ''
        },
        showRefresh: {
            type: Boolean,
            default: false
        },
        emitDataType: {
            type: String,
            default: 'base'
        },
    },

    computed: {
        leftOptionsComputed () {
            return this.leftOptions || this.options.find(i => i.type === 'left') || {};
        },
        showRefreshComputed () {
            return this.showRefresh || this.options.find(i => i.type === 'refresh');
        },
        gameList () {
            return this.leftOptionsComputed.datalist || [];
        },
        dateTypeList () {
            return this.dateOptions.datalist || [];
        },
        resultList () {
            const data = Object.keys(this.selectData).reduce((list, key) => {
                const filter = this.options.find(item => item.key === key) || {};
                if (!['select', 'multi-select'].includes(filter.type)) return list;
                if (Array.isArray(this.selectData[key])) {
                    return [...list, ...this.selectData[key]];
                } else if (this.selectData[key]) {
                    return [...list, this.selectData[key]];
                }
                return list;
            }, []);
            const classifyData = [];
            this.options.forEach(item => {
               let obj = {
                 title: item.title,
                 data: data.filter(ele => ele.key === item.key)
               };
               classifyData.push(obj);
            });
            return classifyData.filter(item => item.data.length >0)  //data
        },
        // 时区
        timezone () {
            const key = (this.options.find(i => i.type === 'timezone') || {}).key;
            if (!key) return null;
            return this.selectData[key];
        },

        showDateTips () {
            return this.dateOptions.tips && !(this.showDateDropdown && this.dateOptions.datalist && this.dateOptions.datalist.length);
        },

        dateFilter () {
            return this.options.find(item => item.type === 'date') || {};
        },
        dateOptions () {
            return this.dateFilter.extraOption || {};
        },
        optionsAll () {
            return this.options.concat(this.leftOptionsComputed, this.dateOptions);
        },
        datePickerType () {
            return this.dateFilter.datePickerType || 'daterange';
        },
        disabledDateFn () {
            return this.dateFilter.disabledDateFn || (() => false);
        },

        datePeriod: {
            get () {
                const { starttime, endtime } = this.filterData;
                if (this.datePickerType.includes('range')) {
                    return starttime ? [starttime, endtime] : [];
                }
                return starttime || '';
            },
            set (val) {
                const endFormat = ((time, type = 'month') => dayjs(time).endOf(type).format('YYYY-MM-DD'));
                const dateFormatMap = {
                    daterange: val => val,
                    monthrange: val => [val[0], endFormat(val[1], 'month')],
                    month: val => [val, endFormat(val, 'month')],
                    week: val => [val, endFormat(val, 'isoWeek')]
                };
                const [starttime, endtime] = dateFormatMap[this.datePickerType](val);
                this.$emit('change', { starttime, endtime });
            }
        },
        shortcuts () {
            return this.dateFilter.shortcuts || [
                '今天',
                '昨天',
                '最近7天',
                '最近14天',
                '最近30天',
            ];
        },
        customShortcuts () {
            return this.dateFilter.customShortcuts || {};
        },
        dateText () {
            const { starttime, endtime } = this.filterData;
            let text = getQuickTime(starttime, endtime);
            text = text || (starttime ? '自定义' : '默认时间');
            return text;
        },
        dateName () {
            const { starttime, endtime } = this.filterData;
            let NO_TIME = '请选择时间范围';
            if (!starttime || !endtime) {
                return NO_TIME;
            }
            if (this.datePickerType === 'week') {
                return `${dayjs(starttime).year()} 年 第 ${dayjs(endtime).startOf('isoWeek').isoWeek()} 周`;
            }
            let preFormat = 'YYYY年MM月';
            let subFormat = 'YYYY年MM月';
            if (this.datePickerType === 'month') {
                return dayjs(starttime).format(preFormat);
            }
            if (this.datePickerType.includes('date')) {
                preFormat = 'YYYY年MM月DD日';
                subFormat = (dayjs(starttime).year() !== dayjs().year()) ? 'YYYY年MM月DD日' : 'MM月DD日';
            }
            return `${dayjs(starttime).format(preFormat)}-${dayjs(endtime).format(subFormat)}`;
        },
        pickerOptionsComputed () {
            if (this.datePickerType.includes('range')) {
                const customShortcuts = this.customShortcuts;
                return Object.assign({},
                    {
                        disabledDate: (time) => this.disabledDateFn(time)
                    },
                    this.shortcuts.length > 0 && {
                        shortcuts: getShortcuts(this.shortcuts, customShortcuts),
                    }
                );
            }

            return Object.assign({}, { firstDayOfWeek : 1 }, {
                disabledDate: (time) => this.disabledDateFn(time),
            });
        },
    },

    data () {
        return {
            selectData: {},
            effectedMap: {},
            innerLists: {},
            dateWidth: 'auto',
            dateFlag: false,
            isWaiting: false,
            showDateDropdown: false,
        };
    },

    mounted () {
        this.$nextTick(() => {
            this.setDateWidth();
            this.setEffectedMap();
        });
    },

    methods: {
        waitFn () {
            return new Promise((resolve, reject) => {
                if (this.isWaiting) {
                    reject();
                    setTimeout(() => {
                        this.isWaiting = false;
                    }, 60);
                    return;
                } else {
                    this.isWaiting = true;
                    resolve();
                    setTimeout(() => {
                        this.isWaiting = false;
                    }, 60);
                }
            });
        },
        handleRefresh () {
            this.$emit('refresh');
        },

        handleDateDropdown (val) {
            this.showDateDropdown = val;
        },

        handleImageError (event) {
            let img = event.srcElement;
            img.src = defaultImage;
            img.onerror = null;
        },

        setInnerLists () {
            const effectList = {};
            for (const key in this.effectedMap) {
                const option = (this.optionsAll.find(i => i.key === key) || {});
                const originList = option.datalist || [];
                const effectKeys = this.effectedMap[key];
                effectList[key] = originList.filter(i => {
                    return effectKeys.every(efKey => {
                        const currFilter = this.optionsAll.find(i => i.key === efKey) || {};
                        const effectkey = currFilter.effectKey || efKey;
                        const value = this.getItemValueName(currFilter);
                        // 判断currVal的数据类型
                        let currVal = this.filterData[efKey] || [];
                        if (Array.isArray(currVal)) {
                            currVal = (currVal || []).map(curr => curr[value]);
                        } else {
                            currVal = (`${currVal}` || '').split(',');
                        }
                        if (currVal.length) {
                            const currArr = Array.isArray(i[effectkey]) ? i[effectkey].map(t => `${t}`) : `${i[effectkey]}`.split(',');
                            return currVal.some(select => currArr.includes(`${select}`));
                        }
                        return true;
                    });
                });
            }
            for (const option of this.options) {
                if (!effectList[option.key]) {
                    effectList[option.key] = option.datalist || [];
                }
            }
            this.innerLists = effectList;
        },

        setDateWidth () {
            const el = document.getElementById('dateNameWrap');

            if (!el) {
                this.dateWidth = 'auto';
                return ;
            }
            this.dateWidth = el.offsetWidth + 15 + 'px';
        },
        getIconUrl (item = {}, filter) {
            let iconUrl = '';
            if (filter.propsMapper && filter.propsMapper.icon) {
                iconUrl = item[filter.propsMapper.icon];
            }
            iconUrl = item.icon_url || defaultImage;
            return iconUrl;
        },
        getGameName (item = {}, filter) {
            return this.getItemLabel(item, filter) || '';
        },

        handleDateClick () {
            if (this.$refs.dapDateRefs) {
                if (this.$refs.dapDateRefs[0].$el.className.includes('is-active') && this.dateFlag) {
                    this.$refs.dapDateRefs[0].handleClose();
                }
            }

            this.dateFlag = !this.dateFlag;
        },
        handleDateBlur () {
            this.dateFlag = false;
            this.setDateWidth();
        },

        getItemDisabled (item, filter) {
            return item.disabled || (() => {
                const value = this.getItemValueName(filter);
                if (this.selectData[filter.key]) {
                    if (Array.isArray(this.selectData[filter.key])) {
                        return this.selectData[filter.key].some(i => i[value] === item[value]);
                    }
                    return item[value] === this.selectData[filter.key][value];
                }
                return false;
            })();
        },

        getItemValue (item, filter) {
            return item[this.getItemValueName(filter)];
        },

        getItemValueName (filter) {
            if (filter.propsMapper && filter.propsMapper.value) {
                return filter.propsMapper.value;
            }
            return 'id';
        },

        getItemLabel (item = {}, filter) {
            if (filter.propsMapper && filter.propsMapper.value) {
                return item[filter.propsMapper.label];
            }
            return item.name;
        },

        iconPopoverOption (filter) {
            return {
                ...filter.iconPopoverOption,
                disabled: !(!filter?.iconPopoverOption?.disabled && this.getIconPopover(filter))
            }
        },

        getIconPopover (filter) {
            if(filter.iconPopoverOption && !filter.iconPopoverOption.disabled) {
                return filter.iconPopoverOption.tips;
            }
            return null;
        },

        itemPopoverOption (item = {}, filter) {
            return {
                ...filter.itemPopoverOption,
                'popper-class': 'top-item-popover',
                disabled: !(!filter?.itemPopoverOption?.disabled && this.getItemPopover(item, filter))
            }
        },

        getItemPopover (item = {}, filter) {
            if(filter.itemPopoverOption && !filter.itemPopoverOption.disabled) {
                const key = item[filter.propsMapper.value];
                return filter.itemPopoverOption.tips[key];
            }
            return null;
        },

        getSelectItem (item, filter) {
            if (filter.propsMapper && filter.propsMapper.value) {
                return {
                    ...item,
                    key: filter.key,
                    propsMapper: filter.propsMapper
                };
            }
            return {
                ...item,
                key: filter.key
            };
        },

        async setSelectData () {
            await this.waitFn().catch(_ => {});
            this.setInnerLists();
            const val = this.filterData;
            for (const filter of this.optionsAll) {
                const { key, datalist = [] } = filter;
                const value = this.getItemValueName(filter);
                let currVal = val[key];
                // eslint-disable-next-line
                if (!val.hasOwnProperty(key)) {
                    this.selectData[key] = undefined;
                    continue;
                } else if (filter.type === 'multi-select') {
                    this.selectData[key] = [];
                    // 判断currVal的数据类型
                    if (Array.isArray(currVal)) {
                        currVal = (currVal || []).map(curr => curr[value]);
                    } else {
                        currVal = (currVal || '').split(',');
                    }
                    if (currVal.length) {
                        currVal.forEach(select => {
                            const item = datalist.find(i => `${i[value]}` === `${select}`);
                            item && this.handleFilterChoose(item, filter);
                        });
                    }
                } else if (filter.type === 'timezone') {
                    this.handleFilterChoose(currVal, filter);
                } else {
                    this.selectData[key] = undefined;
                    const currValStr = currVal instanceof Object ? currVal[value] : currVal;
                    const item = datalist.find(i => `${i[value]}` === `${currValStr}`);
                    item && this.handleFilterChoose(item, filter);
                }
            }
        },

        setEffectedMap () {
            this.optionsAll.forEach(i => {
                if (i.effect && i.effect.length) {
                    const effects = i.effect || [];
                    for (const key of effects) {
                        if (!this.effectedMap[key]) {
                            this.effectedMap[key] = [i.key];
                        } else if (!this.effectedMap[key].includes(i.key)) {
                            this.effectedMap[key].push(i.key);
                        }
                    }
                }
            });
        },

        handleFilterChange (item, filter) {
            if (filter.disabled) return;
            console.log('filter',filter)
            const { key } = filter;
            const obj = this.filterChoose(item, filter);
            let emitItem = obj[key];
            this.emitOutterFn(emitItem, filter);
        },

        handleChangeTimezone (filter) {
            let timezoneList = filter.datalist || [0, 8];
            const currentTimezoneIndex = timezoneList.findIndex(i => i === this.timezone) || 0;
            const nextTimezoneIndex = (currentTimezoneIndex + 1) % timezoneList.length;
            this.handleFilterChange(timezoneList[nextTimezoneIndex], filter)
        },

        emitOutterFn (emitItem, filter) {
            const { key } = filter;
            if (this.getEmitType(filter) === 'base') {
                if (!['number', 'string', 'undefined'].includes(typeof emitItem)) {
                    emitItem = Array.isArray(emitItem) ?
                        emitItem.map(i => this.getItemValue(i, filter)).toString() :
                        this.getItemValue((emitItem || {}), filter)
                }
            }
            const emitObj = (filter.effect || []).reduce((res, item) => ({
                ...res,
                [item]: undefined
            }), {[key]: emitItem});
            this.$emit('change', emitObj);
        },

        getEmitType (filter) {
            const emitDataType = filter.emitDataType || this.emitDataType;
            return emitDataType === 'whole' ? 'whole' : 'base';
        },

        handleFilterChangeId (id, filter) {
            const valKey = this.getItemValueName(filter);
            this.handleFilterChange(filter.datalist.find(i => i[valKey] === id) || {}, filter);
        },

        filterChoose (item, filter) {
            // 处理选择的值
            const { type, key, disabled } = filter;
            const value = this.getItemValueName(filter);
            let obj = { ...this.selectData };
            obj[key] = item;
            if (type === 'select') {
                obj[key] = this.getSelectItem(item, filter);
            }
            if (type === 'multi-select') {
                obj[key] = (this.selectData[key] && this.selectData[key].every(i => item[value] !== i[value])) ?
                    this.selectData[key].concat(this.getSelectItem(item, filter)) :
                    (this.selectData[key] || [this.getSelectItem(item, filter)]);
            }
            if (type === 'timezone') {
                obj[key] = item === undefined ? 8 : item;
            }
            return obj;
        },

        filterChooseInner (item, filter) {
            const { type, key, disabled } = filter;
            const obj = this.filterChoose(item, filter);
            return this.handleEffect(( type === 'date' ? this.datePeriod : obj[key] ), filter, obj);
        },

        handleFilterChoose (item, filter) {
            const { type, key } = filter;
            const obj = this.filterChoose(item, filter);
            this.selectData = obj;
            // this.selectData = this.handleEffect(( type === 'date' ? this.datePeriod : obj[key] ), filter, obj);
        },

        handleEffect (item, filter, obj) {
            if (filter.effect && filter.effect.length) {
                for (const efKey of filter.effect) {
                    obj[efKey] = undefined;
                }
            }
            // 如果有回调
            if (filter.effectFn) {
                return filter.effectFn(item, filter, obj) || obj;
            }
            return obj;
        },

        removeResult (result = {}) {
            // 移除结果集
            const { key } = result;
            const filter = this.options.find(i => i.key === key) || {};
            const value = this.getItemValueName(filter);
            let obj = this.selectData[key];
            obj = Array.isArray(obj) ? obj.filter(i => i[value] !== result[value]) : undefined;
            this.selectData = {
                ...this.selectData,
                [key]: obj
            };
            let emitItem = obj;
            this.emitOutterFn(emitItem, filter);
        },

        isShowRemoveBtn (result) {
            const { key } = result;
            const filter = this.options.find(i => i.key === key) || {};
            // if (filter.canDelete === false) {
            //     return (Array.isArray(this.selectData[key]) && this.selectData[key].length > 1);
            // }
            return !(filter.canDelete === false || filter.filterable === false);
        },
    },

    watch: {
        filterData: {
            handler () {
                this.setSelectData();
            },
        },
        optionsAll: {
            handler () {
                this.setSelectData();
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss">
.dap-select__auto-width {
    min-width: 100px;

    .el-input__prefix {
        position: relative;
        left: 0px;
        box-sizing: border-box;
        border: 1px solid #ffffff00;
        padding: 0 30px 0 15px;
        height: 34px;
        line-height: 34px;
        visibility: hidden;
    }

    input {
        position: absolute;
        height: 34px;
        line-height: 34px;
        padding: 0 30px 0 15px;
    }
}
.relative { position: relative; }
.hand { cursor: pointer; }
.el-select.none-border .el-input input.el-input__inner {
    font-size: 12px;
}
.el-select.none-border {
    .el-input {
        input.el-input__inner {
            border: none;
            padding-left: 0;
        }
    }
}
.bold { font-weight: bold; }
.hide-element { display: none !important; }
.el-range-editor .el-range-input {
    cursor: pointer;
}
.dap-top-data-filter {
    height: 60px;
    background-color: #fff;
    box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.12);
    width: 100%;
    margin-bottom: 10px;
    padding: 14px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .not-allowed {
        cursor: not-allowed;
    }

    .el-select.none-border .el-input input.el-input__inner {
        font-size: 14px !important;
    }

    .gameImg {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        border: 1px solid #F2F6FC;
    }
    .dap-top-filter-left {
        justify-self: flex-start;
        display: flex;
        align-items: center;
    }
    .dap-top-filter-right {
        max-width: calc(100% - 200px);
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-self: flex-end;
        .date-type-tip-wrap {
            position: absolute;
            width: 75px;
            top: 0;
            left: 11px;
            line-height: 20px;
            text-align: left;
        }
        .date-type-tip {
            text-align: left;
        }
        .hasDateOptions {
            min-width: 150px;
        }
        .result-cn{
          height: 40px;
          overflow-y: visible !important;
          overflow-x: visible !important;
        
          .m-r-4{
            margin-right: 0 !important;
          }
       }
       .tag-area{
          display: flex;
          flex: 1;
          overflow-x: auto;
            &::-webkit-scrollbar{
                height: 4px;
          }
       }
       .tag-content{
          display: flex;
          align-items: center;
          flex-shrink: 0;
       }
       .tag-classify{
           font-size: 12px;
           color: #999999;
           flex-shrink: 0;
       }
       .tag-item{
        color: #606266;
       }
      
    }
}
.dap-dropdown {
    padding: 6px 0;
    .el-dropdown-menu__item {
        font-size: 12px;
        padding: 0 15px;
        line-height: 27px;
    }
}
.dap-extra-dropdown {
    max-height: 240px;
    overflow-y: auto;
    white-space: nowrap;
}
// 顶部通栏
.dap-top-data-filter {
    color: rgb(96, 98, 102);

    .data-filter-dap-date-picker-react {
        position: relative;
        width: 80px;
        height: 17px;
        // overflow: hidden;
        margin-left: 29px;
        opacity: 0;

        .el-range-editor--small.el-input__inner {
            // margin-left: -85px;
            margin-top: -10px;
            width: auto;
            height: 58px;

            input.el-range-input {
                cursor: pointer;
            }
        }
        .el-date-editor.el-input {
            input.el-input__inner {
                cursor: pointer;
            }
        }

        .el-range__close-icon {
            display: none;
        }

        .el-input__suffix, .el-input__prefix {
            display: none;
        }

    }

    .date-react-word-wrap {
        width: calc(100% - 10px);
        position: absolute;
        top: -8px;
        left: 0;
        pointer-events: none;
        .date-react-word {
            width: 100px;
            height: 17px;
            line-height: 17px;
            text-align: right;
            background-color: transparent;
            float: right;
            width: calc(100% - 29px);
        }
    }

    .result-cn {
        margin-right: 10px;
        display: flex;
        align-items: center;
        overflow-y: auto;
    }

    .result-wrapper {
        white-space: nowrap;
        background-color: #fff;
        border-radius: 3px;
        padding: 0 4px;
        margin-right: 4px;
        border-radius: 4px;
        border: 1px solid #F4F4F4;
        position: relative;
        
        > i {
            display: none;
            color: #909399;
            position: absolute;
            right: -6px;
            top: -6px;
        }
        &:hover{
            .el-icon-error {
                display: inline-block;
            }
        }
    }

    .area-type-tip {
        display: none;
        left: -60px;
        top: 20px;
        right: -58px;
        background: #fff;
        padding: 10px;
        z-index: 9999;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
        .arrow {
            position: absolute;
            left: 80px;
            top: -6px;
            margin-right: 3px;
            display: block;
            width: 0;
            height: 0;
            border-color: transparent;
            border-style: solid;
            border-width: 6px;
            border-top-width: 0;
            border-bottom-color: #fff;
            filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));

        }
    }

    .date-type-tip-wrap {
        position: absolute;
        left: 11px;
        top: -5px;
        width: 75px;
        .date-type-ul {
            max-height: 240px;
            // overflow-y: auto;
            transform-origin: center top;
            margin: 5px 0;
            background-color: #fff;
            border: 1px solid #EBEEF5;
            border-radius: 4px;
            box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
            // margin-top: 3px;
            list-style: none;
            padding: 6px 0;
            width: 84px;
            z-index: 100;
            position: relative;
            left: -7px;
            .date-type-li {
                line-height: 27px;
                padding: 0 15px;
                font-size: 12px;
                color: #606266;
                outline: none;
                cursor: pointer;
                &:hover {
                    background-color: #ecf3fe;
                    color: #689df6;
                }

            }

            .date-type-arrow {
                display: inline-block;
                width: 0;
                height: 0;
                position: absolute;
                top: -5px;
                left: 34px;
                z-index: 999;
                border-width: 0 5px 5px;
                border-style: solid;
                border-color: transparent transparent #FFF;
            }
        }
        .date-type-tip {
            width: 130px;
            padding: 10px;
            background-color: #fff;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
            border: 1px solid #EBEEF5;
            position: absolute;
            top: 25px;
            left: -33px;
            display: none;

            &:before {
                content: "";
                width: 0px;
                height: 0px;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 8px solid rgba(0, 0, 0, 0.1);
                // box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
                position: absolute;
                top: -8px;
                left: 65px;
            }
            &:after{
                content: "";
                width: 0px;
                height: 0px;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 8px solid #FFFFFF;
                // box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
                position: absolute;
                top: -8px;
                left: 65px;
            }
        }

        &:hover {
            .date-type-tip {
                display: block;
                z-index: 1;
            }
            .area-type-tip {
                display: block;
                z-index: 1;
            }
        }
    }
}

.timezone-wrap {
    user-select: none;
    margin-right: 25px;
    margin-top: 2px;
    color: rgb(96, 98, 102);

    .timezone-tip {
        font-size: 10px;
        color: #fff;
        display: inline-block;
        height: 18px;
        line-height: 18px;
        background: #FFB300;
        border-radius: 4px;
        position: absolute;
        right: -40px;
        top: -12px;
    }

    .timezone-tip-reset {
        padding: 0 !important;
        width: 22px;
        text-align: center;
    }

    .timezone-tip-react {
        right: -18px;
        top: -8px;
    }

    @media not all and (min-resolution:.001dpcm) {
        .timezone-tip {
            right: -26px;
        }
    }
}

.data-filter-popper.el-date-range-picker {
    width: 514px;

    &.has-sidebar {
        width: 613px;
    }

    .el-picker-panel__sidebar {
        // padding-top: 14px;
        width: 90px;
        .el-picker-panel__shortcut {
            line-height: 26px !important;
            cursor: pointer;
            font-size: 12px !important;

            &:hover {
                background-color: #f3f4f4;
            }
        }
    }

    &.has-sidebar .el-picker-panel__body {
        margin-left: 100px;
    }



    .el-date-range-picker__content {
        padding: 12px 8px;

        .el-date-range-picker__header {
            height: 20px;

            div {
                font-size: 12px;
            }
        }

        .el-date-table {
            th {
                padding: 0;
            }

            td {
                height: 24px;

                div {
                    height: 20px;

                    span {
                        font-size: 10px;
                        width: 16px;
                        height: 16px;
                        line-height: 16px;
                    }
                }

                &.in-range {
                    div {
                        background-color: #f3f4f4;
                    }
                }
            }
        }
    }
}

.el-date-range-picker.data-filter-popper-2 {
    .el-picker-panel__sidebar {
        .el-picker-panel__shortcut {
            line-height: 23px !important;
        }
    }
}
.el-select-dropdown.el-popper {
    .el-select-dropdown__item {
        font-size: 12px;
        &.selected {
            font-weight: normal;
        }
    }
}

.el-dropdown-small .el-dropdown-menu__item {
    line-height: 27px;
    padding: 0 15px;
    font-size: 13px;
}

.top-item-popover {
    box-sizing: border-box;
    margin-right: 5px !important;
    width: 123px !important;
    min-width: 123px !important;
}
</style>
